// extracted by mini-css-extract-plugin
module.exports =  {"explainTextDataGrid":"explainTextDataGrid_c7todWiH"};